// [messaging.message-presentation](../../../docs/product/messaging-and-notifications.md#messaging-message-presentation): this inactivity interval is our choice; Messenger's threshold was not verified.
const MESSAGE_TIME_GAP_MS = 15 * 60 * 1000;

function messageDate(iso?: string | null): Date | null {
  if (!iso) return null;
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? null : date;
}

// Format the server timestamp in the viewer's local timezone, including its
// zone label for disclosure; missing/invalid historical timestamps stay unknown.
export function exactMessageTime(iso?: string | null): string {
  const date = messageDate(iso);
  return date ? date.toLocaleString([], {
    month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit", timeZoneName: "short",
  }) : "";
}

// [messaging.message-presentation](../../../docs/product/messaging-and-notifications.md#messaging-message-presentation): day boundaries follow the viewer's calendar, while inactivity uses
// elapsed milliseconds. Sender changes alone do not repeat a time marker.
export function messageTimeSeparator(currentIso?: string | null, previousIso?: string | null): string | null {
  const current = messageDate(currentIso);
  if (!current) return null;
  const previous = messageDate(previousIso);
  const differentDay = !previous || current.getFullYear() !== previous.getFullYear()
    || current.getMonth() !== previous.getMonth() || current.getDate() !== previous.getDate();
  if (differentDay) return current.toLocaleString([], {
    month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit",
  });
  if (current.getTime() - previous.getTime() >= MESSAGE_TIME_GAP_MS) {
    return current.toLocaleTimeString([], { hour: "numeric", minute: "2-digit" });
  }
  return null;
}
